
import { useEffect, useState } from "react";

import ResumeData from "./ResumeData";
import { useDispatch, useSelector } from "react-redux";
import { deleteResume, getResume } from "./ResumeSlice";
import { Button } from "react-bootstrap";
import { toast } from "react-toastify";
import DeleteDialog from "../../../component/resuable/deleteDialog";
import StyledDataTable from "../../../component/resuable/StyledComponent";
import Header from "../../Navbar/Header";
import Sidebar from "../sidebar/Sidebar";
import Cookies from 'js-cookie';
import refreshIcon from "../../../assests/images/refreshIcon.png"
import { useLocation } from "react-router-dom";
import LoadingSpinner from "../../../component/resuable/LoadingSpinner";

export default function IntermediateResume() {
    const location = useLocation();
    let role = Cookies.get("role");
    const dispatch = useDispatch();
    const [cellclicked, setCellclicked] = useState("");
    const [search, setSearch] = useState("");
    const [isLoading, setIsLoading] = useState(false);
    const [selectedValue, setSelectedValue] = useState('');
    const [currentPage, setCurrentPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(20);
    const [showDeleteDialog, setShowDeleteDialog] = useState(false);
    const [deleteId, setDeleteId] = useState(null);
    const [selectedData, setselectedData] = useState("");
    const [editData, setEditData] = useState("");
    const [activeTab, setActiveTab] = useState("pending");
    // const [refreshData, setRefreshData] = useState(false);

    const handleClick = () => {
        setCellclicked('add')
        setEditData('');
    }
    const handleBack = () => {
        console.log("active tab value", activeTab);
        fetchData()
        setActiveTab(activeTab)
        setCellclicked('')
        setEditData('');
        // setRefreshData(prev => !prev);

    }


    const handleDelete = async (id) => {
        setIsLoading(true);
        setShowDeleteDialog(false);
        const response = await dispatch(deleteResume(id))
        if (response.payload.status === 200) {
            fetchData()
            setIsLoading(false);
            setDeleteId(null);
            toast.success("User Data Deleted successfully");
            // setRefreshData(prev => !prev);
        }

    };


    const handleEditClick = (data) => {
        setCellclicked('edit');
        setEditData(data);

    };


    const handleDeleteClick = (data) => {
        setselectedData(data.name)
        setDeleteId(data.id);
        setEditData(data);
        setShowDeleteDialog(true);

    };
    function capitalizeWords(str) {
        if (str !== undefined) {
            return str
                .toLowerCase()
                .split(' ')
                .map(word => word.charAt(0).toUpperCase() + word.slice(1))
                .join(' ');
        } else {
            return ""
        }
    }

    const truncateTableCellData = (value) => {
        if (!value) return "";
        return value.length > 30 ? value.slice(0, 30) + "..." : value;
    };

    const columns = [
        {
            name: "S.No",

            selector: (row, index) => (currentPage - 1) * itemsPerPage + index + 1,
            width: '5%'
        },
        {
            name: 'Name',
            selector:
                (row) =>
                    <div
                        className="table_data_truncate_tooltip_cell"
                        title={row.name}
                    >
                        {truncateTableCellData(capitalizeWords(row.name))}
                    </div>,
            // selector: (row) => capitalizeWords(row.name),
            width: '15%'
        },
        // {
        //     name: 'Email',
        //     selector: (row) => row.email,
        //     width: '15%'
        // },
        {
            name: 'Gender',
            selector: (row) => truncateTableCellData(row.sex),
            width: '12%'
        }, {
            name: 'Address',
            selector: (row) => <div
                className="table_data_truncate_tooltip_cell"
                title={row.communication ? truncateTableCellData(row.communication) : ""}
            >
                {truncateTableCellData(row.communication)}
            </div>,
            width: "15%",
        },
        // {
        //     name: 'Status',
        //     selector: (row) => row.status,
        //     width: '10%'
        // },

        {
            name: 'Language',
            selector: (row) => <div
                className="table_data_truncate_tooltip_cell"
                title={truncateTableCellData(row.language)}
            >
                {row.language}
            </div>,
            width: "9%"
        },
        {
            name: 'Date',
            selector: (row) => <div
                className="table_data_truncate_tooltip_cell"
                title={truncateTableCellData(row.date)}
            >
                {row.date}
            </div>,
            width: "8%"
        },
        ...(role === "admin" || role ==="intermediate" ? [
            {
                name: 'English Pdf',
                width: '12%',
                selector: (row) => (
                    <a href={row.english_pdf} target="_blank" rel="noopener noreferrer" >
                        {row.english_pdf !== null ? "Download" : "--"}
                    </a>
                ),
            },
            {
                name: 'Japanese Pdf',
                width: '15%',
                selector: (row) => (
                    <a href={row.japanese_pdf} target="_blank" rel="noopener noreferrer">
                        {row.japanese_pdf !== null ? "Download" : "--"}
                    </a>
                ),
            }
        ] : [
            {
                name: 'English Resume',
                width: '12%',
                selector: (row) => (
                    <a href={row.file_download} target="_blank" rel="noopener noreferrer" >
                        Download
                    </a>
                ),
            },
            {
                name: 'Japanese Resume',
                width: '15%',
                selector: (row) => (
                    <a href={row.japanese_file_path} target="_blank" rel="noopener noreferrer">
                        {row.japanese_file_path !== null ? "Download" : "--"}
                    </a>
                ),
            }]),
        {
            name: "Action",
            cell: (row) => (
                <>
                    <Button variant="danger" className="table-viewcustom-button" onClick={() => handleEditClick(row)}>
                        <i className="fas fa-eye px-2"></i>
                    </Button>
                    {role === 'admin' && (
                        <Button variant="primary" className="table-custom-button" onClick={() => handleDeleteClick(row)} style={{ marginRight: '8px' }} >
                            <i className="fas fa-trash px-2"></i>
                        </Button>)}

                </>
            ),
            button: true
        }
    ];

    const [rowData, setRowData] = useState([]);
    const candiateData = useSelector(state => state.Resume.resumeData);
    const { pendingCount, completedCount } = useSelector(state => state.Resume);

    const fetchData = async () => {
        const status = activeTab === "pending" ? "pending" : "completed";

        await dispatch(getResume({ page: currentPage, perPage: itemsPerPage, search: search, status: selectedValue, management_status: status }));
    };


    useEffect(() => {


        fetchData();
    }, [dispatch, currentPage, itemsPerPage, search, selectedValue, activeTab]);



    useEffect(() => {
        if (candiateData && Array.isArray(candiateData.candidates)) {
            const formattedData = candiateData.candidates.map((user) => ({
                name: user.name,
                email: user.email,
                phone: user.phone,
                skill: user.skill,
                // status: user.status,
                // current_salary: user.current_salary,
                // expected_salary: user.expected_salary,
                sex: user.sex,
                file_download: user.file_download,
                // location: user.location,
                // mode: user.mode,
                id: user.id,
                years_of_exp: user.years_of_exp,
                language: user.language,
                japanese_file_path: user.japanese_file_path,
                notice_period: user.notice_period,

                arrival_date: user.arrival_date ? new Date(user.arrival_date) : '',
                // contact_details: user.contact_details,
                emergency_contact: user.emergency_contact,
                coe: user.coe,
                employement_contract: user.employement_contract,
                air_ticket: user.air_ticket,
                passport_copy: user.passport_copy,
                resident_copy: user.resident_copy,
                visa: user.visa,
                remarks: user.remarks,
                option_file: user.option_file,
                employeer_name: user.employeer_name,

                //new fields
                admission_number: user.admission_number,
                ad_fees: user.ad_fees,
                date_of_admission: user.date_of_admission ? new Date(user.date_of_admission) : '',
                // date_of_admission: user.date_of_admission,
                dob: user.dob ? new Date(user.dob) : '',
                passport_no: user.passport_no,
                height: user.height,
                weight: user.weight,
                marital_status: user.marital_status,
                nationality: user.nationality,
                religion: user.religion,
                communication: user.communication,
                reference: user.reference,
                educational_qualification: user.educational_qualification,
                additional_qualification: user.additional_qualification,
                english_knowledge: user.english_knowledge,
                profile_pic: user.profile_pic,
                sign: user.sign,
                educationalCertificate: user.educationalCertificate,
                medicalReport: user.medicalReport,
                vaccinationCertificate: user.vaccinationCertificate,

                age: user.age,
                place_of_birth: user.place_of_birth,
                reason_for_apply: user.reason_for_apply,
                cooperative_living: user.cooperative_living,
                favorite_subject: user.favorite_subject,
                licenses_and_qualifications: user.licenses_and_qualifications,
                tattoo: user.tattoo,
                blood_type: user.blood_type,
                right_vision: user.right_vision,
                left_vision: user.left_vision,
                color_blindness: user.color_blindness,
                blood_pressure: user.blood_pressure,
                dominant_hand: user.dominant_hand,
                foods_cannot_eat: user.foods_cannot_eat,
                smoking: user.smoking,
                drinking_beer: user.drinking_beer,
                hobbies: user.hobbies ? user.hobbies.split(',') : [],
                strengths: user.strengths ? user.strengths.split(',') : [],
                weaknesses: user.weaknesses ? user.weaknesses.split(',') : [],
                medical_history: user.medical_history,
                spouse: user.spouse,
                personal_income: user.personal_income,
                family_income: user.family_income,
                relatives_in_japan: user.relatives_in_japan,
                japanese_address: user.japanese_address,
                experience_coming_to_japan: user.experience_coming_to_japan,
                desired_years_to_work_in_japan: user.desired_years_to_work_in_japan,
                savings_per_year: user.savings_per_year,
                plans_or_goals_after_returning: user.plans_or_goals_after_returning,
                version: user.version,
                academic_details: user.academic_details,
                family_details: user.family_details,
                work_experience_list: user.work_experience_list,
                english_pdf: user.english_pdf,
                japanese_pdf: user.japanese_pdf,
                date: user.date,

            }));
            console.log("formatted data", formattedData);

            setRowData(formattedData);
        }
    }, [candiateData]);

    const handlePageChange = (page) => {
        setCurrentPage(page);
    };

    const handleRowsPerPageChange = (newPerPage) => {
        setItemsPerPage(newPerPage);  // Update rows per page
        setCurrentPage(1);  // Reset to the first page when changing rows per page
    };
    const handleSelectChange = (event) => {
        setSelectedValue(event.target.value);
    };

    const handleTabClick = (tab) => {
        setActiveTab(tab); // Set active tab
    };

    return (
        <>
            {
                isLoading && <LoadingSpinner />
            }
            <div className='container-fluid' >
                <div className='row'>
                    <Header />
                    <div className='col-2 p-0'>
                        <Sidebar />
                    </div>
                    <div className='col-10 mt-2 px-3'>
                        <div className='card custom-card'>
                            <div className='row justify-content-center'>
                                {cellclicked === "" && (
                                    <div>
                                        <div className="col-md-12">
                                            <div className="row py-3">
                                                <div className="col-md-3">
                                                </div>
                                                <div className="col-md-5 ">
                                                    <div className="d-flex">
                                                        <input placeholder="search" className="form-control me-4" onChange={(e) => setSearch(e.target.value)} />
                                                        {/* <select value={selectedValue} onChange={handleSelectChange} className="form-select">
                                                            <option value="" disabled selected>Select an option</option>
                                                            <option value="Immediate Joiner">Immediate Joiner</option>
                                                            <option value="Notice Period">Notice Period</option>
                                                        </select>
                                                            <img src={refreshIcon} alt="refreshicon" onClick={() => {
                                                            setSelectedValue("")
                                                        }} className="px-2 mt-2 cursor-pointer" height={20} width={35}/> */}
                                                    </div>

                                                </div>
                                                <div className="col-md-4 text-end">
                                                    {role === 'admin' && (
                                                        <button className='btn defult-button defult-button-head mx-2' type="buttons" onClick={handleClick}>Add New</button>)}
                                                </div>
                                            </div>
                                        </div>


                                        <div className='col-md-5 px-4'>
                                            <ul className="nav nav-pills" id="pills-tab" role="tablist">
                                                <li className="nav-item" role="presentation">
                                                    <button className={`nav-link custom-link ${activeTab === "pending" ? "active" : ""}`} id="pills-home-tab" data-bs-toggle="pill" data-bs-target="#pills-home" type="button" role="tab" aria-controls="pills-home" aria-selected="true" onClick={() => handleTabClick("pending")}>Pending Items ({pendingCount})</button>
                                                </li>
                                                <li className="nav-item" role="presentation">
                                                    <button className={`nav-link custom-link  ${activeTab === "completed" ? "active" : ""}`} id="pills-profile-tab" data-bs-toggle="pill" data-bs-target="#pills-profile" type="button" role="tab" aria-controls="pills-profile" aria-selected="false" onClick={() => handleTabClick("completed")} >Completed Items ({completedCount})</button>
                                                </li>

                                            </ul>
                                        </div>

                                        <div className='row'>
                                            <div className="tab-content" id="pills-tabContent">
                                                <div className="tab-pane fade show active" id="pills-home" role="tabpanel" aria-labelledby="pills-home-tab">
                                                    <div className="mt-2 ">
                                                        <StyledDataTable
                                                            columns={columns}
                                                            data={rowData.length > 0 ? rowData : []}
                                                            highlightOnHover
                                                            pagination
                                                            paginationServer
                                                            paginationPerPage={itemsPerPage}
                                                            paginationRowsPerPageOptions={[5, 10, 15]}
                                                            paginationTotalRows={candiateData.total}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleRowsPerPageChange}
                                                            responsive
                                                            persistTableHead={true}
                                                            paginationDefaultPage={currentPage}
                                                        />
                                                    </div>
                                                </div>
                                                <div className="tab-pane fade" id="pills-profile" role="tabpanel" aria-labelledby="pills-profile-tab">
                                                    <div className="mt-2">
                                                        <StyledDataTable
                                                            columns={columns}
                                                            data={rowData.length > 0 ? rowData : []}
                                                            highlightOnHover
                                                            pagination
                                                            paginationServer
                                                            paginationPerPage={itemsPerPage}
                                                            paginationRowsPerPageOptions={[5, 10, 15]}
                                                            paginationTotalRows={candiateData.total}
                                                            onChangePage={handlePageChange}
                                                            onChangeRowsPerPage={handleRowsPerPageChange}
                                                            responsive
                                                            persistTableHead={true}
                                                            paginationDefaultPage={currentPage}
                                                        />
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                )}

                                {cellclicked === "add" && (
                                    <ResumeData handleBack={handleBack} />
                                )}

                                {cellclicked === "edit" && (
                                    <ResumeData handleBack={handleBack} editData={editData} />
                                )}
                                {showDeleteDialog && deleteId && (
                                    <DeleteDialog
                                        id={deleteId}
                                        data={selectedData}
                                        onDelete={handleDelete}
                                        onClose={() => setShowDeleteDialog(false)}
                                    />
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>

        </>
    );
}
